import { render, staticRenderFns } from "./MFCs.vue?vue&type=template&id=0bff8d31&scoped=true"
import script from "./MFCs.vue?vue&type=script&lang=js"
export * from "./MFCs.vue?vue&type=script&lang=js"
import style0 from "./MFCs.vue?vue&type=style&index=0&id=0bff8d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff8d31",
  null
  
)

export default component.exports